import styles from "./toast.module.scss";
import Button from "../button/Button";

const ToastMessage = ({ message, onDismiss }) => {
  return (
    <div className={styles.layout}>
      <div className={styles.modal}>
        <div className={styles.message}>{message}</div>
        <div className={styles.footer}>
          <Button style={styles.button} onClick={onDismiss}>
            Ok
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ToastMessage;
